import { render, staticRenderFns } from "./NosotrosView.vue?vue&type=template&id=1f59e124&scoped=true&"
import script from "./NosotrosView.vue?vue&type=script&lang=js&"
export * from "./NosotrosView.vue?vue&type=script&lang=js&"
import style0 from "./NosotrosView.vue?vue&type=style&index=0&id=1f59e124&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59e124",
  null
  
)

export default component.exports